// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkout-page[data-v-7d75c0d6]{text-align:left;padding:.5em 2em 1em}", ""]);
// Exports
module.exports = exports;
